import { useContext, useState, useEffect } from 'react'; 
import PageContext from './PageContext';
import Grid from '@mui/material/Grid';
import SpendPieChart from './SpendPieChart'; 
import SpendBarChart from './SpendBarChart'; 
import PageDropdown from './PageDropdownWithIdObj'; 
import PageReadOnlyInput from './PageReadOnlyInput'; 
import moneyFormat from '../functions/moneyFormat';
import SpendLineChart from './SpendLineChart'; 

const PayoutDetailsGraphs = () => {
    // get page context from parent
    const { 
        isLoading, 
        spendPieData, 
        spendBarData, 
        showSpendBarKeys, 
        spendBarFilter, 
        setSpendBarFilter, 
        spendBarFilterList, 
        spendBarYAxis, 
        totalAggregateSpend, 
        spendLineData, 
        showSpendLineKeys, 
        spendLineFilter, 
        setSpendLineFilter, 
        spendLineFilterList, 
        spendLineXAxis, 
        showSpendLineYAxis, 
        monthlyLineData, 
        showMonthlyLineKeys,  
        monthlyLineXAxis, 
        showMonthlyLineYAxis, 
        monthlyLineFilter,   
        setMonthlyLineFilter, 
        monthlyLineFilterList, 
        onSpendPieClick, 
    } = useContext(PageContext); 

    // set color state for graphs 
    const [colors, setColors] = useState(null); 

    useEffect(() => {
        if (process.env.REACT_APP_GRAPH_COLORS != ''){
            setColors(colors => colors = process.env.REACT_APP_GRAPH_COLORS.split(', ')); 
        }
    }, []); 

    useEffect(() => {
        console.log(spendBarFilter); 
        console.log(spendBarFilterList); 
    }, [spendBarFilter]); 
    
    return (
        <>
            <Grid container spacing={2}>
                <Grid item xs={5}>
                    <Grid className='graph-label-div'container>
                        <Grid item xs={6}>
                            <label style={{marginTop: '8px', marginLeft: '15px', float: 'left'}}><b>Aggregated Cyle Spend: </b></label>
                        </Grid>
                        <Grid item xs={6}>
                            <PageReadOnlyInput 
                                tag='Total' 
                                value={moneyFormat(totalAggregateSpend)} 
                                // width={'200px'}
                                width={'15vw'}
                                />
                        </Grid>
                    </Grid>
                    <Grid className='graph-label-div' style={{height: '365px'}} container>
                        <Grid style={{margin: 'auto'}} item xs={12}>
                            <SpendPieChart tags={['companyid']} data={spendPieData} onClick={onSpendPieClick} isLoading={isLoading} colors={colors} />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={7}>
                    <Grid className='graph-label-div' container>
                        <Grid item xs={6}>
                            <label style={{marginTop: '8px', marginLeft: '15px', float: 'left'}}><b>Cycle Spend/Rebate By Period: </b></label> 
                        </Grid>
                        <Grid item xs={6}>
                            <PageDropdown tag={'Filter'} list={spendBarFilterList} obj={spendBarFilter} setObj={setSpendBarFilter} />
                        </Grid>
                    </Grid>
                    <Grid className='graph-label-div' style={{height: '365px'}} container>
                        <Grid item xs={12}>
                            <SpendBarChart data={spendBarData} keys={showSpendBarKeys} axis={spendBarYAxis} isLoading={isLoading} colors={colors}/>
                        </Grid> 
                    </Grid>
                </Grid>
                <Grid item xs={12}> 
                    <Grid className='graph-label-div' container>
                        <Grid item xs={9}>
                            <label style={{marginTop: '8px', marginLeft: '15px', float: 'left'}}><b>Cycle Spend/Rebate YoY: </b></label> 
                        </Grid>
                        <Grid item xs={3}>
                            <PageDropdown tag={'Filter'} list={spendLineFilterList} obj={spendLineFilter} setObj={setSpendLineFilter} />
                        </Grid>
                    </Grid>
                    <Grid className='graph-label-div' style={{height: '365px'}} container>
                        <Grid item xs={12}>
                            <SpendLineChart data={spendLineData} keys={showSpendLineKeys} xAxisProp={spendLineXAxis} yAxisProp={showSpendLineYAxis} isLoading={isLoading} colors={colors}/>
                        </Grid> 
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Grid className='graph-label-div' container>
                        <Grid item xs={9}>
                            <label style={{marginTop: '8px', marginLeft: '15px', float: 'left'}}><b>Monthly Spend/Rebate YoY: </b></label> 
                        </Grid>
                        <Grid item xs={3}>
                            <PageDropdown tag={'Filter'} list={monthlyLineFilterList} obj={monthlyLineFilter} setObj={setMonthlyLineFilter} />
                        </Grid>
                    </Grid>
                    <Grid className='graph-label-div' style={{height: '365px'}} container>
                        <Grid item xs={12}>
                            <SpendLineChart data={monthlyLineData} keys={showMonthlyLineKeys} xAxisProp={monthlyLineXAxis} yAxisProp={showMonthlyLineYAxis} isLoading={isLoading} colors={colors}/>
                        </Grid> 
                    </Grid>
                </Grid>
            </Grid>
            <br /><br />
        </>
    ); 
}

export default PayoutDetailsGraphs; 